import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { gtmEventHandler } from '@common/utils/gtm';
import { useMediaQuery } from '@common/hooks';

import { updateRequestParams } from '@alumni_v2/stores/reviews/actions';
import { requestParamsSelector } from '@alumni_v2/selectors/reviews';

import AdvancedFilters from '@alumni_v2/ui/ReviewFiltersRevamp/AdvancedFilters';
import QuickFilters from '@alumni_v2/ui/ReviewFiltersRevamp/QuickFilters';
import FilterTagsNew from '@alumni_v2/ui/ReviewFiltersRevamp/FilterTagsNew';
import {
  clearPreSelectedFilters,
} from '@alumni_v2/utils/setPreSelectedFilters';

import { ExperienceFilter, SalaryHikeFilter } from './RangeFilters';

import styles from './ReviewFiltersRevamp.module.scss';


const ReviewFiltersRevamp = () => {
  const { mobile } = useMediaQuery();
  const requestParams = useSelector(requestParamsSelector) || {};
  const dispatch = useDispatch();
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [experienceFilter, setExperienceFilter] = useState({
    min: 2,
    max: 5,
  });
  const [salaryHikeFilter, setSalaryHikeFilter] = useState({
    min: 0,
    max: 900,
  });
  const [advancedFiltersMobile, setAdvancedFiltersMobile] = useState({});
  const [advancedFilters, setAdvancedFilters] = useState({
    currentCompany: null,
    currentStatus: null,
    targetRole: null,
    targetCompany: null,
    currentCollege: null,
  });


  const clearAllFilters = useCallback(() => {
    dispatch(updateRequestParams([], {}, null));
    setAdvancedFilters({
      currentCompany: null,
      currentStatus: null,
      targetRole: null,
      targetCompany: null,
      currentCollege: null,
    });
    setSelectedFilters([]);
    setExperienceFilter({ min: 2, max: 5 });
    setSalaryHikeFilter({ min: 0, max: 900 });
    setAdvancedFiltersMobile({});
    clearPreSelectedFilters();
  }, [dispatch]);

  const showRangeFilters = useCallback(() => {
    if (requestParams.search
      || requestParams.quickFilters?.length
      || Object.keys(requestParams.advancedFilters || {}).length) return true;
    return false;
  }, [
    requestParams.advancedFilters,
    requestParams.quickFilters, requestParams.search]);

  const trackNoAlumniFound = useCallback(() => {
    gtmEventHandler(
      'cta',
      'no_alumni_match',
      'click',
      'alumni_directory',
      {
        click_type: 'no_alumni_match',
        gtm_custom_attributes: {
          current_role: advancedFilters.currentStatus?.label || null,
          current_company: advancedFilters.currentCompany?.label || null,
          target_role: advancedFilters.targetRole?.label || null,
          target_company: advancedFilters.targetCompany?.label || null,
          college: advancedFilters.currentCollege?.label || null,
          experience: {
            min: experienceFilter?.min ?? null,
            max: experienceFilter?.max ?? null,
          },
          salary_hike: {
            min: salaryHikeFilter?.min ?? null,
            max: salaryHikeFilter?.max ?? null,
          },
          quick_filters: selectedFilters,
        },
      },
    );
  }, [
    advancedFilters.currentCollege, advancedFilters.currentCompany,
    advancedFilters.currentStatus, advancedFilters.targetCompany,
    advancedFilters.targetRole, experienceFilter, salaryHikeFilter,
    selectedFilters]);

  return (
    <div className={styles.container}>
      <AdvancedFilters
        advancedFilters={advancedFilters}
        setAdvancedFilters={setAdvancedFilters}
      />
      <QuickFilters
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        showRangeFilters={showRangeFilters()}
        experienceFilter={experienceFilter}
        setExperienceFilter={setExperienceFilter}
        salaryHikeFilter={salaryHikeFilter}
        setSalaryHikeFilter={setSalaryHikeFilter}
        advancedFiltersMobile={advancedFiltersMobile}
        setAdvancedFiltersMobile={setAdvancedFiltersMobile}
      />
      {
        showRangeFilters() && !mobile && (
          <div className={styles.sliderFilters}>
            <ExperienceFilter
              experienceFilter={experienceFilter}
              setExperienceFilter={setExperienceFilter}
            />
            <SalaryHikeFilter
              salaryHikeFilter={salaryHikeFilter}
              setSalaryHikeFilter={setSalaryHikeFilter}
            />
          </div>
        )
      }
      <div className={styles.filterTags}>
        <FilterTagsNew
          clearAllFilters={clearAllFilters}
          trackNoAlumniFound={trackNoAlumniFound}
        />
      </div>
    </div>
  );
};

export default ReviewFiltersRevamp;
